import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Eye, EyeOff } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b32b0f5b-4b52-4c01-8ed0-3269ece4932a/artifacts/gm1lpq5e_Capture%20d%E2%80%99e%CC%81cran%202026-04-08%20a%CC%80%2016.29.35.png";

export const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        const result = await login(email, password);
        
        if (result.success) {
            navigate('/');
        } else {
            setError(result.error);
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-4" data-testid="login-page">
            <div className="w-full max-w-md">
                <div className="bg-white border border-[#E4E4E7] p-8">
                    <div className="text-center mb-8">
                        <img src={LOGO_URL} alt="UNeedServices" className="h-16 mx-auto mb-6" />
                        <h1 className="text-2xl font-bold text-[#0A0A0A] tracking-tight">Connexion</h1>
                        <p className="text-[#52525B] mt-2">Accédez à votre espace CRM</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        {error && (
                            <div className="bg-[#DC2626]/10 border border-[#DC2626] text-[#DC2626] px-4 py-3 text-sm" data-testid="login-error">
                                {error}
                            </div>
                        )}

                        <div className="space-y-2">
                            <Label htmlFor="email" className="field-label">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="votre@email.fr"
                                required
                                className="h-12 rounded-sm border-[#E4E4E7] focus:ring-[#E85A24]/50"
                                data-testid="login-email"
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="password" className="field-label">Mot de passe</Label>
                            <div className="relative">
                                <Input
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    className="h-12 rounded-sm border-[#E4E4E7] focus:ring-[#E85A24]/50 pr-12"
                                    data-testid="login-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-[#52525B] hover:text-[#0A0A0A]"
                                    data-testid="login-password-toggle"
                                >
                                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>

                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full h-12 bg-[#E85A24] hover:bg-[#CC4D1C] text-white font-semibold rounded-sm"
                            data-testid="login-submit"
                        >
                            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Se connecter'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};
